<div class="questions-wrapper">
  <form [formGroup]="questionsForm" class="questions-form">
    <h2 class="questions-title">{{ 'jobQuestions.aFewQuickQuestions' | translate }}</h2>

    <ng-container *ngIf="sortedQuestions.length > 0; else noQuestions">
      <div class="field-group" *ngFor="let q of sortedQuestions; let i = index">
        <label class="field-label">
          {{ q.question }}
          <span class="required-star" *ngIf="q.required">*</span>
        </label>
        <textarea
          class="field-textarea"
          [formControlName]="controlKey(i)"
          [placeholder]="'jobQuestions.yourAnswer' | translate"
          rows="3">
        </textarea>
        <span class="field-error" *ngIf="isInvalid(i)">
          {{ 'validation.required' | translate }}
        </span>
      </div>
    </ng-container>

    <ng-template #noQuestions>
      <p class="no-questions-msg">{{ 'jobQuestions.noQuestionsForThisPosition' | translate }}</p>
    </ng-template>
  </form>

  <div class="actions-row">
    <button class="cancel-btn border-button" type="button" (click)="onCancel()">
      {{ 'jobQuestions.cancel' | translate }}
    </button>
    <button class="next-btn gradient-button" type="button"
      (click)="onNext()" [disabled]="questionsForm.invalid">
      {{ 'jobQuestions.next' | translate }}
    </button>
  </div>
</div>